import { ProjectTemplateDisplay } from 'components/ProjectTemplateDisplay'
// import { ProjectDirectoryDisplay } from 'components/ProjectDirectoryDisplay'
import { ProjectTemplatesList } from 'components/ProjectTemplatesList'
import React, { FC, useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { TemplateDocument, UrlParams } from 'types'
import { ProjectRolesList } from 'components/ProjectRolesList'
import { ProjectStatus } from 'components/ProjectStatus'
import { useProjectsForCompany } from 'hooks/useProjectsForCompany'
import { defaultTemplateId } from 'utils/constants'

export const ProjectTemplates: FC<UrlParams> = ({ companyId, projectId }) => {
  const [activeTemplate, setActiveTemplate] = useState<
    TemplateDocument | undefined
  >()
  useEffect(() => {
    setActiveTemplate(undefined)
  }, [setActiveTemplate, projectId])


  const projectList = useProjectsForCompany(companyId)
  const project: any = projectList.find((company: any) => company.id === projectId)

  return (
    <Row>
      <Col lg={2}>
        <ProjectRolesList companyId={companyId} projectId={projectId} templateDocumentId={defaultTemplateId}></ProjectRolesList>
        <ProjectTemplatesList
          onClick={setActiveTemplate}
          activeTemplate={activeTemplate}
          companyId={companyId}
          projectId={projectId}
        />
        {(project?.isCompanyManager || project?.isProjectManager || project?.isProjectCoordinator) && <ProjectStatus project={project} />}
      </Col>
      {activeTemplate?.isDirectory ?
        null :
        (<Col>
          <ProjectTemplateDisplay
            templateDocument={activeTemplate}
            companyId={companyId}
            projectId={projectId}
            setActiveTemplate={setActiveTemplate}
          />
        </Col>)
      }
    </Row>
  )
}